<div style="width:100%;max-height:80vh;background:#ffffff;border-radius:16px;display:flex;flex-direction:column;overflow:hidden;">
  <div style="display:flex;align-items:flex-start;justify-content:space-between;padding:24px 28px;border-bottom:1px solid #eef1f4;">
    <div>
      <h1 style="margin:0 0 4px;font-size:17px;font-weight:800;">{{ 'proposals.dialogs.selectOffer.title' | transloco }}</h1>
      <p style="margin:0;font-size:13px;color:#8892a0;">{{ 'proposals.dialogs.selectOffer.subtitle' | transloco }}</p>
    </div>
    <button type="button" (click)="close()" [attr.aria-label]="'common.close' | transloco" style="border:none;background:transparent;cursor:pointer;padding:8px;border-radius:8px;min-height:44px;min-width:44px;">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6L6 18"/><path d="M6 6l12 12"/></svg>
    </button>
  </div>

  <div style="padding:18px 28px 0;">
    <div style="position:relative;max-width:360px;">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#adb6c1" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round" style="position:absolute;left:12px;top:50%;transform:translateY(-50%);"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>
      <input [(ngModel)]="searchTerm" (ngModelChange)="findAll()" [attr.placeholder]="'proposals.dialogs.selectOffer.searchPlaceholder' | transloco"
        style="width:100%;box-sizing:border-box;border:1px solid #d7dce2;border-radius:9px;padding:10px 12px 10px 36px;font-size:13.5px;">
    </div>
  </div>

  <div style="padding:16px 28px 0;overflow:auto;flex:1;">
    <table style="width:100%;border-collapse:collapse;">
      <thead>
        <tr>
          <th class="dso-th">{{ 'proposals.dialogs.selectOffer.columns.supplier' | transloco }}</th>
          <th class="dso-th">{{ 'proposals.dialogs.selectOffer.columns.ref' | transloco }}</th>
          <th class="dso-th">{{ 'proposals.dialogs.selectOffer.columns.species' | transloco }}</th>
          <th class="dso-th">{{ 'proposals.dialogs.selectOffer.columns.dimensions' | transloco }}</th>
          <th class="dso-th">{{ 'proposals.dialogs.selectOffer.columns.date' | transloco }}</th>
          <th class="dso-th">{{ 'proposals.dialogs.selectOffer.columns.dryOrSawn' | transloco }}</th>
          <th class="dso-th">{{ 'proposals.dialogs.selectOffer.columns.originPort' | transloco }}</th>
          <th class="dso-th">{{ 'proposals.dialogs.selectOffer.columns.quantity' | transloco }}</th>
          <th class="dso-th">{{ 'proposals.dialogs.selectOffer.columns.pricePerM3' | transloco }}</th>
          <th class="dso-th" style="width:44px;"></th>
        </tr>
      </thead>
      <tbody>
        <tr class="dso-row" data-offer-row *ngFor="let offer of offers">
          <td class="dso-td">{{ offer?.supplier?.name }}</td>
          <td class="dso-td" style="color:#8892a0;font-variant-numeric:tabular-nums;">{{ offer?.number }}</td>
          <td class="dso-td" style="font-weight:600;">{{ offer?.specy?.name }}</td>
          <td class="dso-td" style="font-variant-numeric:tabular-nums;" data-testid="offer-dimensions">{{ formatOfferDimensions(offer) }}</td>
          <td class="dso-td" style="font-variant-numeric:tabular-nums;" data-testid="offer-date">{{ formatOfferDate(offer?.date) }}</td>
          <td class="dso-td">{{ offer?.dryType?.name }} / {{ offer?.sawnType?.name }}</td>
          <td class="dso-td">{{ offer?.originPort?.name }}</td>
          <td class="dso-td" style="font-variant-numeric:tabular-nums;">{{ offer?.quantity?.quantity }}m³</td>
          <td class="dso-td" style="font-weight:700;font-variant-numeric:tabular-nums;">{{ price(offer) | currency: priceCurrency(offer) : 'symbol-narrow' }}</td>
          <td class="dso-td">
            <button type="button" (click)="saveAndClose(offer)" [attr.aria-label]="'proposals.dialogs.selectOffer.addAria' | transloco" class="dso-add">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14"/><path d="M5 12h14"/></svg>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div *ngIf="errorMessage" style="margin:0 28px;padding:10px 14px;background:#fdf1d6;color:#92610a;font-size:12.5px;font-weight:600;border-radius:9px;">
    {{ errorMessage }}
  </div>

  <div style="display:flex;align-items:center;justify-content:space-between;padding:16px 28px;border-top:1px solid #eef1f4;">
    <span style="font-size:12.5px;color:#8892a0;">{{ 'proposals.dialogs.selectOffer.showingCount' | transloco: { count: offers.length } }}</span>
    <button type="button" (click)="close()" style="border-radius:9px;font-size:13.5px;font-weight:600;padding:10px 18px;min-height:44px;border:1px solid #d7dce2;background:#ffffff;color:#0f172a;cursor:pointer;">{{ 'common.close' | transloco }}</button>
  </div>
</div>
